import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=03441fa0"
import script from "./NewAccount.vue?vue&type=script&lang=ts"
export * from "./NewAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports